/**
 * 推送相关工具类
 */

/**
 * 设置用户ID为推送别名
 * @param {string} userId 用户ID
 * @returns {Promise} 设置结果
 */
export function setUserIdAsAlias(userId) {
  return new Promise((resolve, reject) => {
    // 检查是否在Android环境中
    if (typeof window !== 'undefined' && window.WebViewJavascriptBridge) {
      // 调用Android原生方法
      window.WebViewJavascriptBridge.callHandler('setUserIdAsAlias', userId, (response) => {
        try {
          const result = JSON.parse(response)
          if (result.code === '1') {
            console.log('设置用户别名成功:', result.message)
            resolve(result)
          } else {
            console.error('设置用户别名失败:', result.message)
            reject(new Error(result.message))
          }
        } catch (error) {
          console.error('解析推送响应失败:', error)
          reject(error)
        }
      })
    } else {
      // 非Android环境，直接返回成功
      console.log('非Android环境，跳过推送别名设置')
      resolve({ code: '1', message: '非Android环境，跳过设置' })
    }
  })
}

/**
 * 清除用户推送别名
 * @returns {Promise} 清除结果
 */
export function clearUserIdAlias() {
  return setUserIdAsAlias('')
}

/**
 * 获取推送RegistrationId
 * @returns {Promise<string>} RegistrationId
 */
export function getPushRegistrationId() {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && window.WebViewJavascriptBridge) {
      window.WebViewJavascriptBridge.callHandler('getPushRegistrationId', '', (response) => {
        try {
          const result = JSON.parse(response)
          if (result.code === '1') {
            resolve(result.data)
          } else {
            reject(new Error(result.message))
          }
        } catch (error) {
          reject(error)
        }
      })
    } else {
      reject(new Error('非Android环境'))
    }
  })
}

/**
 * 检查通知权限
 * @returns {Promise<number>} 权限状态 (1: 已启用, 0: 未启用, -1: 未知)
 */
export function checkNotificationPermission() {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && window.WebViewJavascriptBridge) {
      window.WebViewJavascriptBridge.callHandler('checkNotificationPermission', '', (response) => {
        try {
          const result = JSON.parse(response)
          if (result.code === '1') {
            resolve(result.data)
          } else {
            reject(new Error(result.message))
          }
        } catch (error) {
          reject(error)
        }
      })
    } else {
      resolve(-1) // 非Android环境返回未知状态
    }
  })
}

/**
 * 跳转到通知设置页面
 * @returns {Promise} 跳转结果
 */
export function goToNotificationSettings() {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && window.WebViewJavascriptBridge) {
      window.WebViewJavascriptBridge.callHandler('goToNotificationSettings', '', (response) => {
        try {
          const result = JSON.parse(response)
          if (result.code === '1') {
            resolve(result)
          } else {
            reject(new Error(result.message))
          }
        } catch (error) {
          reject(error)
        }
      })
    } else {
      reject(new Error('非Android环境'))
    }
  })
}
